import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { useNavigate } from 'react-router-dom';
import { usePopularEvents } from '@/hooks';
import PopularEventCard from '@/components/common/PopularEventCard';

const HeaderTopGames = () => {
  const navigate = useNavigate();
  const { events, getStartTime } = usePopularEvents();

  return (
    <Swiper
      slidesPerView={2}
      spaceBetween={4}
      loop={events.length > 2}
      className="w-full max-xl:px-[5px] xl:px-2 xl:hidden"
    >
      {events.map((event, index) => (
        <SwiperSlide key={index}>
          <PopularEventCard
            name={event.name}
            sport={event.sport}
            startTime={getStartTime(event.id)}
            onClick={() => navigate(`/game-details/${event.sport}/${event.id}`)}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default HeaderTopGames;
